import React, { Component } from "react"

import { Row, Col, Card, CardBody } from "reactstrap"

import avatar1 from "assets/images/chart-kattami-bg.jpg"
import profileImg from "assets/images/profile-img.png"
import { getuserDashboard } from "store/group/dashboard/actions"

import PropTypes from "prop-types"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

class WelcomeComp extends Component {
  constructor(props) {
    super(props)
    this.state = {
      roleDescription : '',
    }
  }

  componentDidMount() {

    if (sessionStorage.getItem("userDashboardRole")) {
        const obj = JSON.parse(sessionStorage.getItem("userDashboardRole"))
        this.setState({ roleDescription: obj.roleDescription })
    }

    const { onGetUserDashboard } = this.props
    onGetUserDashboard()
  }

  

  render() {
    return (
      <React.Fragment>
        <Card className="overflow-hidden">
          <div className="bg-primary bg-soft">
            <Row>
              <Col xs="7">
                <div className="text-primary p-3">
                  <h5 className="text-primary">Welcome Back !</h5>
                  <p>Kattam Dashboard</p>
                </div>
              </Col>
              <Col xs="5" className="align-self-end">
                <img src={profileImg} alt="" className="img-fluid" />
              </Col>
            </Row>
          </div>
          <CardBody className="pt-0">
            <Row>
              <Col sm="4">
                <div className="avatar-md profile-user-wid mb-4">
                  <img
                    src={avatar1}
                    alt=""
                    className="img-thumbnail rounded-circle"
                  />
                </div>
               
              </Col>

              <Col sm="8">
                <div className="pt-4">
                 

                </div>
              </Col>
            </Row>
            <Row>
              <Col sm="12">
                
                <h5 className="font-size-15 text-truncate">{this.props.groupUser.firstName} {this.props.groupUser.lastName}</h5>
                <p className="text-muted mb-0 text-truncate">{this.state.roleDescription}{" "} Role </p>
              </Col>
          </Row>
          <Row>
              <Col sm="12">

                <p className="text-muted mb-0 text-truncate">
                <i className={"mdi  mdi-cellphone "} /> {"  "}{this.props.groupUser.mobile}</p>
                <p className="text-muted mb-0 text-truncate">
                <i className={"mdi   mdi-email "} /> {"  "}{this.props.groupUser.email}</p>
               
              </Col>
          </Row>
          </CardBody>
        </Card>
      </React.Fragment>
    )
  }
}

WelcomeComp.propTypes = {
  groupUser : PropTypes.object,
  onGetUserDashboard: PropTypes.func,
}

const mapStateToProps = ({ grpDashboard }) => ({
  groupUser : grpDashboard.userDashboardData,

})

const mapDispatchToProps = dispatch => ({
  onGetUserDashboard: () => dispatch(getuserDashboard()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(WelcomeComp))


